import { render } from "./PanelTemplate.vue?vue&type=template&id=1f0cf94a&ts=true"
import script from "./PanelTemplate.vue?vue&type=script&lang=ts"
export * from "./PanelTemplate.vue?vue&type=script&lang=ts"

import "./PanelTemplate.vue?vue&type=style&index=0&id=1f0cf94a&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__